import React from "react";
import PropTypes from "prop-types";

import MuiDialog from "@mui/material/Dialog";
import isEqual from "lodash-es/isEqual";
import CloseConfirmDialog from "ui/Dialog/CloseConfirmDialog";
import useCloseConfirm from "hooks/useCloseConfirm";

const Dialog = (props) => {
  const {
    children,
    className,
    onClose,
    formik,
    ariaLabelledby = "dialog",
  } = props;
  const { values, initialValues } = formik;
  const {
    showCloseConfirm,
    openCloseConfirm,
    cancelCloseConfirm,
    confirmCloseConfirm,
  } = useCloseConfirm(onClose);

  const handleClose = () => {
    if (isEqual(values, initialValues)) {
      onClose();
      return;
    }
    openCloseConfirm();
  };

  return (
    <>
      <MuiDialog
        open={true}
        onClose={handleClose}
        aria-labelledby={ariaLabelledby.toLowerCase()}
        slotProps={{ paper: { className } }}
      >
        {children}
      </MuiDialog>
      <CloseConfirmDialog
        open={showCloseConfirm}
        onCancel={cancelCloseConfirm}
        onConfirm={confirmCloseConfirm}
      />
    </>
  );
};

export const DialogPropTypes = {
  children: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  formik: PropTypes.any,
};

Dialog.propTypes = DialogPropTypes;

export default Dialog;
